import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

type ChangeNotificationsParams = {
	ReceiveNotifications: boolean;
};

const initialState = null;

export const { thunk: changeNotifications, slice: changeNotificationsSlice } = getThunkAndSlice<ChangeNotificationsParams, null>({
	initialState,
	path: "/api/Account/ChangeNotifications",
	method: "post",
});
